import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isInRecalculation = createSelector(
    onlineOrderState,
    (onlineOrder) => onlineOrder.recalculateRequest.hasSucceeded === true && onlineOrder.recalculateRequest.data !== null,
);
